<template>
  <div class="demo-table-theme">
    <h2>Element UI Table Stripe Theme Demo</h2>
    <el-table :data="tableData" stripe style="width: 100%">
      <el-table-column prop="name" label="Name" />
      <el-table-column prop="age" label="Age" />
      <el-table-column prop="address" label="Address" />
    </el-table>
    <div class="theme-controls">
      <label>Stripe Color:
        <input type="color" v-model="stripeColor" @input="updateTheme" />
      </label>
      <label>Stripe Opacity:
        <input type="range" min="0" max="1" step="0.05" v-model="stripeOpacity" @input="updateTheme" />
        {{ stripeOpacity }}
      </label>
    </div>
  </div>
</template>

<script>
export default {
  name: "DemoTableTheme",
  data() {
    return {
      tableData: [
        { name: "Tom", age: 25, address: "New York" },
        { name: "Jerry", age: 22, address: "London" },
        { name: "Lucy", age: 28, address: "Paris" },
        { name: "Jack", age: 30, address: "Berlin" },
        { name: "Rose", age: 27, address: "Tokyo" },
      ],
      stripeColor: "#f2f2f2",
      stripeOpacity: 1,
    };
  },
  methods: {
    updateTheme() {
      const color = this.stripeColor;
      const opacity = this.stripeOpacity;
      const style = document.createElement("style");
      style.innerHTML = `.el-table--striped .el-table__body tr.el-table__row--striped > td { background-color: ${color}${opacity < 1 ? Math.round(opacity * 255).toString(16).padStart(2, '0') : ''}; background-color: rgba(${parseInt(color.slice(1,3),16)},${parseInt(color.slice(3,5),16)},${parseInt(color.slice(5,7),16)},${opacity}); }`;
      style.id = "stripe-theme-style";
      const old = document.getElementById("stripe-theme-style");
      if (old) old.remove();
      document.head.appendChild(style);
    },
  },
  mounted() {
    this.updateTheme();
  },
};
</script>

<style scoped>
.demo-table-theme {
  max-width: 600px;
  margin: 40px auto;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
  padding: 24px;
}
.theme-controls {
  margin-top: 24px;
  display: flex;
  gap: 24px;
  align-items: center;
}
</style>
